
import './App.css';
import './Styles.css'
import Calculator from "./Calculator";

function App() {
  return (
    <div className="App">
      <Calculator />
      <footer className="App-footer text-center ms-5">
        Coded by Veronica Smigielski
      </footer>
      </div>
  );
}

export default App;
